<template>
    <span :title="JSON.stringify(webhook)">#{{webhook.id}} {{webhook.name}}</span>
</template>

<script>
export default {
    name : "WebhookById",

    props : ['value'],

    data() {
        return {
            webhook : []
        };
    },

    watch : {
        value() {
            this.WebhookApi_findById();
        }
    },

    methods: {
        WebhookApi_findById() {
            var _this = this;
            sdk.WebhookApi().findById({
                id : _this.value
            }).then(res => {
                _this.webhook = res || {};
            });
        }
    },

    mounted() {
        this.WebhookApi_findById();
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/setting/WebhookById.vue